

const controller = function () {
};

controller.$inject = [
];

module.exports = controller;



// WEBPACK FOOTER //
// ./src/app/dash/topControls/dataCaptureSelector/dataCaptureList/DataCaptureListController.js